import { useTranslation } from 'react-i18next';
import { PageHeader } from 'ui/shared/pageHeader';
import { SetupRouter } from './SetupRouter';
import { SetupProvider } from 'hooks/useSetup/useSetup';

export const SetupArea = () => {
    const { t } = useTranslation();
    return (
        <div id="setup-area">
            <PageHeader title={ t('SETUP.TITLE') }/>
            <div id="page-content">
                <SetupProvider>
                    <SetupRouter/>
                </SetupProvider>
            </div>
        </div>
    );
};
